import { Component, Injector, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/Subscription';
import { CommonService } from 'src/app-core/services/common.service';
import { AppComponentBase } from '../app-component-base';
import { CommonDataModel } from '../common-data-model';

@Component({
    selector: 'app-account-tax-configuration',
    templateUrl: './account-tax-configuration.component.html',
    styleUrls: ['./account-tax-configuration.component.scss']
})
export class AccountTaxConfigurationComponent extends AppComponentBase implements OnInit {

    @Input() set accountId(accountId: any) {
        if (accountId) {
            this.accId = accountId;
            this.getTaxConfiguration();
        }
    }

    componentSubscriptions: Subscription = new Subscription();
    commonDataModel = new CommonDataModel();
    accId: any;
    isFormLoading = false;
    taxConfigurationData: any;
    taxConfigurationAll = false;
    customerGuId: string;

    constructor(
        injector: Injector,
        private commonService: CommonService,
        private toastr: ToastrService,
        private activatedRoute: ActivatedRoute,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.componentSubscriptions.add(this.activatedRoute.paramMap.subscribe(params => {
            this.customerGuId = params.get('customerId');
        }));
        this.taxConfigurationData = this.commonDataModel.acconutTaxCondifurationModel;
    }

    getTaxConfiguration() {
        this.isFormLoading = true;
        this.commonService.getAccountTaxConfiguration(this.accId).subscribe((response: any) => {
            this.isFormLoading = false;
            if (response.isSuccess) {
                if (response.data) {
                    this.taxConfigurationData = response.data;
                    this.setTaxAllOption();
                }
            } else {
                this.toastr.error(response.errors, 'Error!');
            }

        });
    }

    setTaxAllOption() {
        this.taxConfigurationAll = true;
        if (!this.taxConfigurationData.material) {
            this.taxConfigurationAll = false;
        }
        if (!this.taxConfigurationData.labor) {
            this.taxConfigurationAll = false;
        }
        if (!this.taxConfigurationData.services) {
            this.taxConfigurationAll = false;
        }
        if (!this.taxConfigurationData.shipping) {
            this.taxConfigurationAll = false;
        }
        if (!this.taxConfigurationData.insurance) {
            this.taxConfigurationAll = false;
        }
    }

    onChangeAll(data: any) {
        this.taxConfigurationData.material = data.checked;
        this.taxConfigurationData.labor = data.checked;
        this.taxConfigurationData.services = data.checked;
        this.taxConfigurationData.shipping = data.checked;
        this.taxConfigurationData.insurance = data.checked;
    }

    onChangeMaterialsCheckbox() {
        this.setTaxAllOption();
    }
    onChangeLaborCheckbox() {
        this.setTaxAllOption();
    }
    onChangeServicesCheckbox() {
        this.setTaxAllOption();
    }
    onChangeShippingCheckbox() {
        this.setTaxAllOption();
    }
    onChangeInsuranceCheckbox() {
        this.setTaxAllOption();
    }

    onChangeStatus() {
        this.commonService.getConfirmationPopup
            (`You want to ${this.taxConfigurationData.isTaxConfigure ? 'Activate' : 'De-active'} Tax Configuration.`,
                'Cancel', 'Confirm').then(result => {
                    if (result) {
                        const reqBody = {
                            accountId: this.customerGuId,
                            isTaxConfigure: this.taxConfigurationData.isTaxConfigure
                        };
                        this.isFormLoading = true;
                        this.commonService.statusChangeAccountTaxConfiguration(reqBody).subscribe((response: any) => {
                            this.isFormLoading = false;
                            if (response.isSuccess) {
                                this.toastr.success(response.errors);
                            } else {
                                this.toastr.error(response.errors, 'Error!');
                            }

                        });
                    } else {
                        this.taxConfigurationData.isTaxConfigure = !this.taxConfigurationData.isTaxConfigure;
                    }
                });
    }

    updateTaxConfiguration() {
        this.isFormLoading = true;
        this.commonService.updateAccountTaxConfiguration(this.taxConfigurationData).subscribe((response: any) => {
            this.isFormLoading = false;
            if (response.isSuccess) {
                this.toastr.success(response.errors);
            } else {
                this.toastr.error(response.errors, 'Error!');
            }

        });
    }

}
